module.exports = __webpack_public_path__ + "static/media/notice2_1.50f62b02.png";